import React, { useState, useCallback, useEffect } from 'react';
import {
    Container,
    PaginationContainer,
    PaginationBottom,
    List,
    Carta,
    Star,
    Selected,
    IconDiv
} from "./styles";

import { ArrowLeftOutlined, ArrowRightOutlined, CheckCircleOutlined, PlusOutlined, CloseOutlined, LoadingOutlined, SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import { notification, Typography, FloatButton, Modal as ModalAnt, Form, Space, Button, Input } from 'antd';
import { useLongPress } from "use-long-press";
import { FocusCarta } from '../MiEquipo/components/modalDetail';
import { useCrearEquipo, useMisCartas } from '../../../../Hooks/Player';

const { Title } = Typography;

const POKECARTASURL = import.meta.env.VITE_POKECARTAS_URL;

export const MisCartas = ({ refetch }) => {
    const [showCard, setShowCard] = useState([false, ""]);
    const [newEquip, setNewEquip] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [imageCache, setImageCache] = useState({});
    const [modalCreate, setModalCreate] = useState(false);

    const [loadingCreate, setLoadingCreate] = useState(false);
  
    const { data, isFetching: cargandoData } = useMisCartas();

    const apiCrearEquipo = useCrearEquipo();

    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const chunkedArray = chunkArray(!cargandoData && (data ?? []), 4);

    const handleNext = () => {
        if (currentIndex < chunkedArray.length - 1) {
            setCurrentIndex(prevIndex => prevIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prevIndex => prevIndex - 1);
        }
    };

    const handleCreateEquip = async () => {
        if (newEquip.length < 7) {
            setLoadingCreate(true);
            const newEquipo = {
                pokes: newEquip,
            };
            const respuesta = await apiCrearEquipo.mutateAsync(newEquipo);
            if (respuesta.success) {
                setNewEquip([]);
                setLoadingCreate(false);
                refetch();
            }
        }
    };

    const handleCardPress = useCallback((idPokemon,poder) => {
        setNewEquip(prev => {
            if (!prev.includes(idPokemon)) {
                if (prev.length < 6) { 
                    setPrePower((prev2) => prev2+poder)
                    return [...prev, idPokemon];
                } else {
                    notification.open({
                        message: "Atención",
                        description: 'El máximo de cartas por equipo es 6',
                    });
                    return prev;
                }
            }
            return prev;
        });
    }, []);

    const currentChunk = chunkedArray[currentIndex] ?? [];

    // Precargar imágenes
    useEffect(() => {
        const cache = {};
        data && data.forEach(item => {
            const url = `${POKECARTASURL}${item.idPokemon}.png`;
            const img = new Image();
            img.src = url;
            cache[item.idPokemon] = img.src;
        });
        setImageCache(cache);
    }, [data]);

    const LongPressCard = React.memo(({ item, onClick, isSelected }) => {
        const longPressHandler = useLongPress(onClick, {
            // onCancel: (event) => ,
            threshold: 500,
            captureEvent: true,
            cancelOnMovement: false,
            cancelOutsideElement: true,
        });
        
        const handlers = longPressHandler("test context");
        const handleOff = () => {
            setNewEquip(prev => prev.filter(i => i !== item.idPokemon))
            setPrePower((prev2) => prev2-item.poder)
        }
        return (
            <div style={{ position: "relative" }} {...handlers}>
                <Carta
                    src={imageCache[item.idPokemon]} // Usar caché
                    onContextMenu={(e) => e.preventDefault()}
                    onClick={() => setShowCard([!showCard[0], `${POKECARTASURL}${item.idPokemon}.png`])}
                />
                {
                    item.cantidad > 1 && <Star><p>{`x${item.cantidad}`}</p></Star>
                }
                {isSelected && (
                    <Selected onContextMenu={(e) => e.preventDefault()} onClick={() => newEquip.includes(item.idPokemon) && handleOff()}>
                        <IconDiv><CheckCircleOutlined style={{ fontSize: '22px', color: 'rgb(120,170,255)' }} /></IconDiv>
                    </Selected>
                )}
    
            </div>
        );
    });

    const [cardSearch, setCardSearch] = useState("");
    const [prePower, setPrePower] = useState(0);

    const handleCancel = () => {
        setNewEquip([])
        setPrePower(0)
    }

    return (
        <Container>
            <Space.Compact style={{ width: "90vw", marginBottom: "20px" }}>
                <Input size="large" placeholder="Qué carta estás buscando?" value={cardSearch} prefix={<SearchOutlined />} suffix={<DeleteOutlined onClick={() => setCardSearch("")} />}  style={{ borderRadius: "25px" }} onChange={(e) => setCardSearch(e.target.value)} />
            </Space.Compact>
            <PaginationContainer>
                <PaginationBottom onClick={handlePrev} disabled={currentIndex === 0}>
                    <ArrowLeftOutlined />
                </PaginationBottom>
                <Title style={{ fontFamily: "POKEFONT", transform: "translateY(-10px)" }} level={5}>
                    {
                        prePower > 0 ? "PODER " + (prePower) : "PÁGINA " + (currentIndex + 1)
                    }
                </Title>
                <PaginationBottom onClick={handleNext} disabled={currentIndex === chunkedArray.length - 1}>
                    <ArrowRightOutlined />
                </PaginationBottom>
            </PaginationContainer>

            <List>
                {!cardSearch && currentChunk?.map(item => {
                    const isSelected = newEquip.includes(item.idPokemon);

                    return (
                        <LongPressCard
                            key={item.idPokemon}
                            item={item}
                            onClick={() => handleCardPress(item.idPokemon, item.poder)}
                            isSelected={isSelected}
                        />
                    );
                })}
                {cardSearch && data?.filter((item) => item.nombre.toLowerCase().includes(cardSearch.toLowerCase())).slice(0, 4).map(item => {
                    const isSelected = newEquip.includes(item.idPokemon);

                    return (
                        <LongPressCard
                            key={item.idPokemon}
                            item={item}
                            onClick={() => handleCardPress(item.idPokemon, item.poder)}
                            isSelected={isSelected}
                        />
                    );
                })}
            </List>
            {newEquip.length > 0 && (
                <>
                    <FloatButton
                        icon={!loadingCreate ? <PlusOutlined style={{ color: 'rgb(44, 62, 80)' }} /> : <LoadingOutlined style={{ color: 'rgb(44, 62, 80)' }} />}
                        shape="circle"
                        style={{ insetInlineEnd: 12, insetBlockEnd: 80 }}
                        onClick={() => setModalCreate(true)}
                    />
                    <FloatButton
                        icon={<CloseOutlined style={{ color: 'white', fontSize: "" }} />}
                        shape="circle"
                        style={{ insetInlineEnd: 15, insetBlockEnd: 135, width: "35px", height: "35px", backgroundColor: "rgb(236,110,111)" }}
                        onClick={() => handleCancel()}
                        type='danger'
                    />
                </>
            )}

            {showCard[0] && <FocusCarta setShowCard={setShowCard} showCard={showCard} fixed={"true"} />}
            {
                modalCreate && 
                <ModalAnt
                    title="Nombre del equipo"
                    open={modalCreate}
                    footer={null}
                    onCancel={() => setModalCreate(false)}
                >
                    <Form
                    name="validateOnly"
                    layout="vertical"
                    autoComplete="off"
                    onFinish={async (e) => {
                        if (newEquip.length < 7) {
                            setLoadingCreate(true);
                            const newEquipo = {
                                pokes: newEquip,
                                nombre: e.nombre ?? null
                            };
                            const respuesta = await apiCrearEquipo.mutateAsync(newEquipo);
                            if (respuesta.success) {
                                setNewEquip([]);
                                setPrePower(0);
                                setLoadingCreate(false);
                                refetch();
                                setModalCreate(false);
                            }
                        }
                    }}
                    >
                        <Form.Item
                            name="nombre"
                            label="Escribe el nombre del equipo a crear (opcional)"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Space>
                                <Button htmlType="submit" type="primary">
                                    Crear
                                </Button>
                                <Button htmlType="reset" onClick={() => setModalCreate(false)}>Cerrar</Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </ModalAnt>
            }

        </Container>
    );
};
